import { createLayoutApp } from "../layout/createLayoutApp";
import CmsNewsListItemAppDestop from "../cmsNewsListItem/CmsNewsListItemAppDestop.vue";
import { setDocumentControllerType } from "../util/controllerHelpers";

const mountEl = document.getElementById("cms-news-list-item");
if (mountEl && mountEl.getAttribute("data-vue3") === "true") {
  setDocumentControllerType("desktop");
  const raw = mountEl.getAttribute("data-view-model");
  const viewModel = raw ? JSON.parse(raw) : null;
  const app = createLayoutApp(CmsNewsListItemAppDestop, { viewModel });
  app.config.globalProperties.$mobile = false;
  app.mount(mountEl);
}